import { useMemo } from 'react'

import * as OrderTexts from '../../../../../../../intl'
import { form } from '../../../../formState'

import { OrderFormValues } from '../../../../typings'
import { Props } from '../../typings'
import { CustomFieldOption } from './types'

import { CustomFieldList } from './components/CustomFieldList'

import { getCustomFieldsValidationErrors } from './validation/getCustomFieldsErrors'

const CUSTOM_FIELD_CONTENTS_SUM_LENGTH = 3000

export function CustomField(props: Props) {
  const { customFields, orderStepType, maxCustomFieldsPerOrder, allowEmptyCustomFields } = props

  const options: CustomFieldOption[] = useMemo(
    () =>
      Array.from(customFields).map(load => ({
        label: load,
        value: load,
      })),
    [customFields],
  )

  const fieldName = `${orderStepType}.customFields` as
    | 'pickup.customFields'
    | 'delivery.customFields'

  form.useAddFieldValidation<typeof fieldName>(fieldName, (field, _formApi) => {
    const customFields = field.value

    if (customFields) {
      const { errors, totalLength, hasValueTooLong } = getCustomFieldsValidationErrors(
        customFields,
        allowEmptyCustomFields,
      )

      if (Object.keys(errors).length > 0) {
        return JSON.stringify(errors)
      }

      if (hasValueTooLong || totalLength > CUSTOM_FIELD_CONTENTS_SUM_LENGTH) {
        return OrderTexts.getValidationErrorCustomFieldMaxContentLengthText()
      }
    }
  })

  return (
    <CustomFieldList<`${typeof orderStepType}.customFields`, OrderFormValues>
      name={`${orderStepType}.customFields`}
      customFieldListInputProps={{
        testId: 'customFields',
        label: OrderTexts.getFieldLabelCustomFieldsText(),
        options,
        maxSelectionsCount: maxCustomFieldsPerOrder,
      }}
    />
  )
}
